"use strict";


//////////////////
// WEBPACK FOOTER
// ./src/containers/BEditor/BEditor.js
// module id = 1756
// module chunks = 0